var  $body, $modal, $secondaryModal, $window,sidebar_pos, sidebar_width,ajax_contents,scroll_from_top,menu_scroll;
var rtime;
var timeout = false;
var delta = 200;
var ash_runned = false;
$(window).resize(function() {
  rtime = new Date();
  if (timeout === false) {
    timeout = true;
    setTimeout(resizeend, delta);
  }
});
function resizeend() {
  if (new Date() - rtime < delta) {
    setTimeout(resizeend, delta);
  } else {
    timeout = false;
    initContent();
  }
}

$(function(){
	"use strict";
	if ("ontouchstart" in window || navigator.msMaxTouchPoints)
	{
		$('body').addClass('touch');
	} else {
		$('body').addClass('no-touch');
	}	
	if($(window).scrollTop() > 50) {
		 $("header").addClass("fixed-nav");
	}
	$(document).on('scroll',function() { 
		if($(window).scrollTop() > 50) {
			 $("header").addClass("fixed-nav");
			$(".sidebar-menu").addClass("fixed-sidebar");
		}else{
			$("header").removeClass("fixed-nav");
			$(".sidebar-menu").removeClass("fixed-sidebar");
		}
	});
	callbacks();
	clickEvents();
	initAshes(20);
});

function ash() {	
	console.log('ash()');
	var el = this;		
	//var $el = $this;
	//window.ash = this;
	el.minDifY = -50;
	el.maxDifY = 400;
	el.minDifX = 50;
	el.maxDifX = 300;
	el.animMinTime = 40;
	el.animMaxTime = 60;
	el.minSize = 15;
	el.maxSize = 80;
	el.images = [SKIN+'img/icons/coffee.svg',
				 SKIN+'img/icons/cupcake.svg',
				 SKIN+'img/icons/glasses.svg',
				 SKIN+'img/icons/lips.svg',
				 SKIN+'img/icons/notebook.svg',
				 SKIN+'img/icons/photograph.svg',
				 SKIN+'img/icons/shoe.svg'];

	el.image = el.images[Math.round(generateRandom(0, el.images.length - 1))];
	el.ashID = 'ash-' + generateRandom(300, 3000);
	el.vWidth = $(window).width();
	el.vHeight = $(window).height();
	el.fireAsh = (generateRandom(0, 10) == 0 ? 'fireAsh' : '');
	el.ashBlock = '<div class="ashWrapper ' + el.fireAsh + '" id="' + el.ashID + '" style="background-image: url(' + el.image + ');background-repeat:no-repeat;"></div>';

	el.createAsh = function() {
		$('#ash_container').append(el.ashBlock);
		return $('#' + el.ashID);
	};

	el.newAsh = el.createAsh();
	el.createAnimation = function() {
		el.startX = generateRandom(-100, el.vWidth);
		el.startY = -30;
		el.aSizeW = generateRandom(el.minSize, el.maxSize);
		el.aSizeH = generateRandom(el.minSize, el.maxSize);
		el.tX = el.startX;
		el.tY = el.startY;
		el.offPage = false;
		el.locs = [];
		el.ashIntro = new TimelineMax({
			onComplete: el.createAnimation,
			autoRemoveChildren: true
		});

		el.ashIntro.add(TweenLite.set(el.newAsh, {
			x: el.startX,
			y: el.startY,
			height: el.aSizeH,
			width: el.aSizeW
		}));

		do {
			if (el.tX > el.vWidth || el.tY > el.vHeight) {
				el.offPage = true;
			}
			el.tX = generateRandom(el.tX + el.minDifX, el.tX + el.maxDifX);
			el.tY = generateRandom(el.tY + el.minDifY, el.tY + el.maxDifY);
			var t1 = {
				x: el.tX,
				y: el.tY
			};

			el.locs.push(t1);

		} while (!el.offPage);
		el.ashIntro.add(TweenLite.to(el.newAsh, generateRandom(el.animMinTime, el.animMaxTime), {
			bezier: {
				curviness: 1.5,
				values: el.locs,
				autoRotate: true
			},
		}), 0);
		el.ashIntro.play();
	};
	el.createAnimation();	
}

function initAshes(ashCount){
	"use strict";	
	var ashes = [];
	console.log('initAshes()');	
	for (var i = 0; i < ashCount; i++) {
		setTimeout(function() {
			ashes[i] = new ash();
		}, 500 * i);
	}
}



function initContent(){
	"use strict";
	/*var iframe = $('.article-content iframe');
	if(iframe.length>0){
		var iframe_width = iframe.innerWidth();
		if(iframe.hasClass('instagram-media')){
			var iframe_height = iframe_width * 1.10;			
		}else{
			var iframe_height = iframe_width * (9/16);
		} 
		iframe.css ({'height':iframe_height});
		
	}	*/
}
function initFeed(){
	"use strict";	
	var $grid = $('.feed-grid').masonry({
	  	horizontalOrder: true
	});	
	$grid.on( 'layoutComplete', function(){
		$('.feed-grid').addClass('loaded');
	});
	
	$grid.imagesLoaded().progress( function() {
	  	$grid.masonry('layout');
	});
	$(window).resize(function(){
		setTimeout(function(){
			$grid.masonry('layout');
		},500);
	});	
}

function registerGAEvent(category,action,title,value){
    if(typeof(ga)!=='undefined'){
        ga('send', 'event', category, action, title, value);
    }
}

function clickEvents(){
	"use strict";
	$('.go-to-anchor').click(function(){
		 event.preventDefault();
        var target = $(this).data('anchor');
		var target_offset = $(target).offset();
        var target_top = target_offset.top;
		
		$('html, body').animate({scrollTop:target_top}, 500);
	});
	$('.search-btn').click(function(){
		$('body').toggleClass('open-search');
		if($('body').hasClass('open-search')){
			$( this ).next().focus();			
			$( this ).next().addClass('active-search');
			
			$(".active-search").bind( "clickoutside", function(){
				$('body').removeClass('open-search');
				$('.active-search').removeClass('active-search');
			});
		}else{
			$('.search-form input' ).each(function(){
				$(this).val('');
				$(this).removeClass('active-search');
			});
		}		
		return false;
	});
	$('.burger').click(function(){
		$('body').toggleClass('open-menu');
		if($('body').hasClass('open-search')){
			$('.active-search').removeClass('active-search');
			$('body').removeClass('open-search');
		}
		return false;
	});	
	
	$('.popup-overlay').click(function(){
		if($('body').hasClass('open-menu')){
			$('.sidebar-menu .animate-delay').each(function(){
				$(this).addClass('no-delay').addClass('no-delay');
			});
			$('body.open-menu').removeClass('open-menu');
			setTimeout(function(){
				$('.sidebar-menu .animate-delay').each(function(){
					$(this).removeClass('no-delay').removeClass('no-delay');
				});	
			},200);
			if($('body').hasClass('open-search')){
				$('input').addClass('no-animate');
				$('body').removeClass('open-search');
				$('.active-search').removeClass('active-search');
				setTimeout(function(){
					$('input').removeClass('no-animate');	
				},200);
			}	
		}
		return false;
	});
	
	$(document).on("click", '.more-results', function () {
		var target = $(this).attr('rel');	
		more(target);
		return false;
	});
}



function initShares(){
	"use strict";
	$('.close-share-this').click(function(){
		$('.modal.in').modal('hide');
		return false;
	});	
	var clipboard = new Clipboard('.clipboardButton');
	clipboard.on('success', function(e) {
		console.info('Action:', e.action);
		console.info('Text:', e.text);
		console.info('Trigger:', e.trigger);
		
		$('.clipboardButton .copy-label').text(' copied!');
		
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
		
	});	
}
$(document).on('click', ".modal-btn", function (e) {
	try{
		e.preventDefault();			
	   if($(this).attr("href")){
			openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));				
		}else{
			openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));				
		}	
	}catch(Error){
		console.log(Error);
	}
	return false;
});
function openAjaxModal(href,$mm){
	
    $m = $mm || $modal;

    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        //skinFormElements('#'+$m.attr('id'));
        callbacks('#'+$m.attr('id'));
    });
}
function more(target){
	var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
	var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val());
	
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	
	$('.more-results[rel="'+target+'"]').addClass('loading');
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize(),
		dataType:'html',
		success:function(data){
			$newItems = $.parseHTML( data );
			$.each( $newItems, function( i, el ) {
				$(el).data('duration', i ).appendTo('#'+target+'-list');			
			});			
			if(next_page===all_pages-1){
				$('.more-results[rel="'+target+'"]').hide();
			}else{
				$('.more-results[rel="'+target+'"]').removeClass('loading');		
			}
		}
	});
}

function callbacks(c) {
	"use strict";
    var container = c || '';
    //ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
                var c = $(this).data();
                for (var i in c) {
                    if (i.indexOf('fn') === 0 && c[i] !== '') {
                        var fn = c[i];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ](params, function(){
                                    window[callbackAfter](callbackAfterParams);
                                });
                            } else {
                                window[ fn ](params);
                            }
							$(this).addClass('callbacks-executed');
                        } catch (Error) {
                            console.log(Error + ' '+fn);
                        }
                    }
                }
            }
        }
    });
}

function ajaxContent(c){
	"use strict";	
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'content':$(this).data('ajaxContent'),
                'target': $(this)
            }
        );
    });
    loadAjaxContent();
}

function generateRandom(min, max) {
	return Math.round(Math.random() * (max - min) + min);
}



function loadAjaxContent(){
	"use strict";
    if(ajax_contents.length > 0){
        var target = ajax_contents[0]['target'],content =  ajax_contents[0]['content'];
        if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');

            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}

